import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { CancelOrderReasonEntity } from '../../domain/entities/CancelOrderReasonEntity'
import type { CancelOrderReasonAdminMiniDto } from '@/backend/market'
export class CancelOrderReasonModel extends CancelOrderReasonEntity {
  constructor(dataDto: CancelOrderReasonAdminMiniDto) {
    super()
    mapEntityProperties<CancelOrderReasonEntity>(this, dataDto)
  }
}
